<template>
  <div class="profile-comments">
    <back-profile @click.native="navigateTo('app.profile.home')"
      >Perfil de {{ studentProfile.student.name }}</back-profile
    >

    <!-- Active alerts -->
    <block style="padding-bottom: 60px;" class="profile-comments__block">
      <template slot="header"
        >Comentarios</template
      >
      <div v-if="studentProfile.latestComments.length" class="comments">
        <div v-for="comment in studentProfile.latestComments" :key="comment.id" class="comment">
          <span v-show="comment.subject" class="is-block">
            {{ comment.subject }}
          </span>
          <span class="is-block"
            >{{ comment.author.name }} - {{ comment.createdAt | humanizeDate }}</span
          >
          <p class="is-marginless comment__text">{{ comment.comment }}</p>
        </div>
      </div>
      <p v-else>No hay comentarios registrados.</p>
    </block>
  </div>
</template>

<script>
import gql from "graphql-tag"
import moment from "moment"

import STUDENT_COMMENTS from "./graphql/StudentComments.gql"
import Block from "@/components/_base/Block.vue"
import BackProfile from "@/components/_base/BackProfile.vue"

export default {
  name: "ProfileComments",
  props: {
    studentId: {
      type: String
    }
  },
  data() {
    return {
      studentProfile: {
        student: {
          name: ""
        },
        latestComments: []
      }
    }
  },
  apollo: {
    studentProfile: {
      query: STUDENT_COMMENTS,
      variables() {
        return {
          studentId: this.studentId,
          n: 100
        }
      }
    }
  },
  components: {
    Block,
    BackProfile
  },
  methods: {
    navigateTo(route) {
      console.log(`Navigating to...${route}`)
      this.$emit("hello", route)
    }
  },
  filters: {
    humanizeDate(date) {
      if (date == null) {
        return "-"
      } else {
        const m = moment(date)
        return m.fromNow()
      }
    }
  }
}
</script>

<style scoped>
.comments {
  margin-bottom: 10px;
}

.comment {
  margin: 30px 0;
  font-size: 16px;
  line-height: 20px;
  color: var(--color-neutral-90);
  font-weight: bold;
}

.comment .comment__text {
  font-size: 14px;
  line-height: 18px;
  font-weight: 400;
  color: inherit;
}
</style>
